/* eslint-disable no-return-await */
import React, { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { MapContainer, GeoJSON } from 'react-leaflet';

import { Card, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import geoViewport from '@mapbox/geo-viewport';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import api from '../../services/api';
import { Translator } from '../../components/i18n';

import 'leaflet/dist/leaflet.css';

function Croquis({ idFazenda }) {
  const erroBuscaDados = Translator({
    path: 'erroBuscaDados',
  });
  const geoJSONref = useRef(null);

  const [selectedCroqui, setSelectedCroqui] = useState(null);
  const [defaultGeoJSON, setDefaultGeoJSON] = useState(null);

  const [modal, setModal] = useState(false);

  const [randomKey, setRandomKey] = useState(1);
  const [map, setMap] = useState();

  const toggle = () => setModal(!modal);

  const infosCroqui = async () => {
    setRandomKey(Math.random());
    setDefaultGeoJSON(null);
    setSelectedCroqui(null);
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const { data } = await api.get(`/ver-croqui/${idFazenda}`);
      setSelectedCroqui(data);

      setTimeout(() => {
        setDefaultGeoJSON(data?.objeto);
      }, 2500);

      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };
  useEffect(() => {
    infosCroqui();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    function updateMap() {
      if (map && selectedCroqui) {
        setTimeout(() => {
          const objZoomViewport = geoViewport.viewport(selectedCroqui?.bounds, [
            window.innerWidth,
            window.innerHeight,
          ]);

          map.flyTo(
            [
              selectedCroqui?.coordenadas?.lati,
              selectedCroqui?.coordenadas?.long,
            ],
            objZoomViewport?.zoom - 2,
            {
              animate: true,
              duration: 2,
            }
          );
        }, 500);
      }
    }
    updateMap();
  }, [map, selectedCroqui]);

  return (
    <>
      <Card>
        {defaultGeoJSON ? (
          <Button onClick={toggle}>
            <Translator path="vercroquigeral" />
          </Button>
        ) : (
          <p>
            <Translator path="semcroquicadastrado" />
          </p>
        )}
      </Card>

      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          <Translator path="mapa.menu.croqui" />
        </ModalHeader>
        <ModalBody>
          {defaultGeoJSON ? (
            <MapContainer
              center={[-16.804541, -56.425781]}
              whenCreated={setMap}
              zoom={3}
              scrollWheelZoom={false}
            >
              <ReactLeafletGoogleLayer
                apiKey="AIzaSyBCdSTyT5w8MEFXVyqz19IV3AMD9D3fUGw"
                type="hybrid"
                useGoogMapsLoader
              />

              {defaultGeoJSON &&
                defaultGeoJSON?.map((e) => (
                  <>
                    <GeoJSON
                      key={e?.fileName + randomKey}
                      ref={geoJSONref}
                      data={e?.features}
                      style={{
                        fill: true,
                        stroke: true,
                        color: '#FFFF00',
                        fillColor: '#FFFF004D',
                        opacity: 0.8,
                        dashArray: '30 10',
                        weight: 2,
                        fillOpacity: 0.8,
                        strokeWidth: 2,
                      }}
                    />
                  </>
                ))}
            </MapContainer>
          ) : (
            <p>
              <Translator path="semcroquicadastrado" />
            </p>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

export default Croquis;
